const PATH_BASE = {
  HOME: '/',
  DATA_ADMIN: '/data-admin',
  DISTRIBUTION_LIST: '/distribution-list',
  EVENT: '/event',
  FORGOT_PASSWORD: '/forgot-password',
  GEO_TEMPLATES: '/geo-templates',
  LICENSES: '/licenses',
  LOGIN: '/login',
  MONITORING_V2: '/monitoringV2',
  OPERATORS: '/operators',
  USER_ADMIN: '/user-admin',
  GOLF_PRICING: '/golf-pricing'
} as const

export const ROUTE_PARAM = {
  OPERATOR_ID: 'operatorId',
  LICENSE_PROPERTY: 'licenseProperty',
  TOURNAMENT_ID: 'tournamentId',
  TOURNAMENT_NAME: 'tournamentName',
  EVENT_ID: 'eventId',
  TEAM_NO: 'teamNo'
} as const

export const ROUTE_URL = {
  HOME: '/',
  LOGIN: PATH_BASE.LOGIN,
  FORGOT_PASSWORD: PATH_BASE.FORGOT_PASSWORD,
  GEO_TEMPLATES: PATH_BASE.GEO_TEMPLATES,
  MONITORING_V2: PATH_BASE.MONITORING_V2,
  DISTRIBUTION_LIST: PATH_BASE.DISTRIBUTION_LIST,
  GOLF_PRICING: {
    DEFAULT: PATH_BASE.GOLF_PRICING,
    TOURNAMENT: `${PATH_BASE.GOLF_PRICING}/:${ROUTE_PARAM.TOURNAMENT_ID}`,
    TOURNAMENT_LEADERBOARD: {
      DEFAULT: `${PATH_BASE.GOLF_PRICING}/:${ROUTE_PARAM.TOURNAMENT_ID}/leaderboard`,
      TEAM: `${PATH_BASE.GOLF_PRICING}/:${ROUTE_PARAM.TOURNAMENT_ID}/leaderboard/:${ROUTE_PARAM.TEAM_NO}`
    },
    TOURNAMENT_ODDS_DATA: `${PATH_BASE.GOLF_PRICING}/:${ROUTE_PARAM.TOURNAMENT_ID}/odds-data`
  },
  OPERATORS: {
    DEFAULT: PATH_BASE.OPERATORS,
    OPERATOR: `${PATH_BASE.OPERATORS}/:${ROUTE_PARAM.OPERATOR_ID}`,
    OPERATOR_USERS: `${PATH_BASE.OPERATORS}/:${ROUTE_PARAM.OPERATOR_ID}/users`,
    OPERATOR_LICENSES: `${PATH_BASE.OPERATORS}/:${ROUTE_PARAM.OPERATOR_ID}/licenses`
  },
  DATA_ADMIN: {
    DEFAULT: PATH_BASE.DATA_ADMIN,
    PLAYER_DATA: {
      DEFAULT: `${PATH_BASE.DATA_ADMIN}/player-data`,
      PLAYERS: `${PATH_BASE.DATA_ADMIN}/player-data/players`,
      QUARANTINE: `${PATH_BASE.DATA_ADMIN}/player-data/quarantine`
    },
    TOURNAMENTS: {
      DEFAULT: `${PATH_BASE.DATA_ADMIN}/tournaments`,
      TOURNAMENT: `${PATH_BASE.DATA_ADMIN}/tournaments/:${ROUTE_PARAM.TOURNAMENT_ID}`
    }
  },
  EVENT: {
    DEFAULT: PATH_BASE.EVENT,
    EVENT_ID: `${PATH_BASE.EVENT}/:${ROUTE_PARAM.EVENT_ID}`
  },
  LICENSES: {
    DEFAULT: PATH_BASE.LICENSES,
    LICENSE: `${PATH_BASE.LICENSES}/:${ROUTE_PARAM.LICENSE_PROPERTY}`
  },
  USER_ADMIN: {
    DEFAULT: PATH_BASE.USER_ADMIN,
    USERS: `${PATH_BASE.USER_ADMIN}/users`
  }
} as const
